import { render } from "./SiteInformation.vue?vue&type=template&id=15711371&scoped=true"
import script from "./SiteInformation.vue?vue&type=script&lang=ts"
export * from "./SiteInformation.vue?vue&type=script&lang=ts"

import "./SiteInformation.vue?vue&type=style&index=0&id=15711371&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-15711371"

export default script